
import { RadioGroup, Radio, Button } from 'vant'
import { ref } from 'vue'

import { chooseAward } from '@/api/sdws.js'
import { useStore } from 'vuex'

export default {
  components: {
    RadioGroup,
    Radio,
    Button,
  },
  emits: ['close'],
  setup(props, ctx) {
    const checked = ref(1)

    const rewardsList = [
      {
        url: '//img11.iqilu.com/29/2022/10/14/ba2de92cf50fc76241ca985f106b0436.png',
        name: '黄河口生态旅游区',
        tips: '门票一张,有效期一年',
        value: 1,
      },
      {
        url: '//img11.iqilu.com/29/2022/10/14/c21d91a5e5e1e4f5c1f6bea4d1af1c64.png',
        name: '龙口南山景区',
        tips: '年卡一张,有效期一年',
        value: 2,
      },
      {
        url: '//img11.iqilu.com/29/2022/10/14/29aa9862eeeef5b8a109daf6b9756c87.png',
        name: '青州古城',
        tips: '年卡一张,有效期一年',
        value: 3,
      },
      {
        url: '//img11.iqilu.com/29/2022/10/14/18bcf8ddc1820dce9e4f73a4e4f175a7.png',
        tips: '年卡一张,有效期一年',
        name: '沂山风景区',
        value: 4,
      },
      {
        url: '//img11.iqilu.com/29/2022/10/14/28945d923031cf79592b332da2c6cff6.png',
        tips: '门票一张,有效期一年',
        name: '趵突泉',
        value: 5,
      },
      {
        url: '//img11.iqilu.com/29/2022/10/14/50f17e089091154ddcc3332ae9586c5c.png',
        tips: '年卡一张,有效期一年',
        name: '沂蒙山龟蒙·云蒙',
        value: 6,
      },
      {
        url: '//img11.iqilu.com/29/2022/10/14/0cfffac0a2e777bd770873c5df0a7b13.jpg',
        tips: '门票一张,有效期一年',
        name: '泰山风景区',
        value: 6,
      },
    ]

    const store = useStore()
    const handleSelect = async () => {
      const res = await chooseAward({
        prize: rewardsList[checked.value].name,
        token: store.getters?.getToken,
      })

      if (res.ok) {
        ctx.emit('close')
      }
    }

    return { checked, rewardsList, handleSelect }
  },
}
